import React, { useState, useRef } from 'react';
import { FaTimes, FaCloudUploadAlt } from 'react-icons/fa';
import Swal from 'sweetalert2';

const AutofillBill = ({ onClose, onSave }) => {
  const [step, setStep] = useState(1); // 1 = Upload, 2 = Loading, 3 = Split View
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState('');
  const [progress, setProgress] = useState(0);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    supplier: '',
    billNo: '',
    billDate: '',
    dueDate: '',
    memo: '',
    lines: []
  });

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
      processFile(selectedFile);
    }
  };

  const processFile = (selectedFile) => {
    setStep(2);
    let currentProgress = 0;

    const interval = setInterval(() => {
      currentProgress += Math.floor(Math.random() * 20) + 15;
      if (currentProgress >= 100) {
        currentProgress = 100;
        clearInterval(interval);

        setTimeout(() => {
          // ✅ File Name se Data nikalne ki Smart Koshish
          const fileName = selectedFile.name.toLowerCase();

          let extractedSupplier = '';
          let extractedBillNo = '';

          // Agar file ke naam mein number hai (jaise invoice_910768.pdf)
          const match = fileName.match(/\d{3,}/);
          if (match) extractedBillNo = match[0];

          // Agar file ke naam mein words hain (jaise wrights_bill.pdf)
          if (fileName.includes('wright')) extractedSupplier = 'Wrights The Dental Supply Co';
          if (fileName.includes('dental')) extractedSupplier = 'Dental Supplies Ltd';

          // ✅ Form mein data set karein (Agar mila toh, warna khali chhorein taake user khud bhare)
          setFormData({
            supplier: extractedSupplier || '',
            billNo: extractedBillNo || '',
            billDate: '', // Date khali rakhenge taake user khud bhare
            dueDate: '',
            memo: `Uploaded file: ${selectedFile.name}`,
            lines: [] // Items khali rakhenge
          });

          setStep(3);
        }, 800);
      }
      setProgress(currentProgress);
    }, 200);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleLineChange = (id, field, value) => {
    setFormData(prev => ({
      ...prev,
      lines: prev.lines.map(line => line.id === id ? { ...line, [field]: value } : line)
    }));
  };

  // Naya line add karne ka function
  const addLine = () => {
    const newId = formData.lines.length > 0 ? Math.max(...formData.lines.map(l => l.id)) + 1 : 1;
    setFormData(prev => ({
      ...prev,
      lines: [...prev.lines, { id: newId, category: '', description: '', amount: '' }]
    }));
  };

  const removeLine = (id) => {
    setFormData(prev => ({
      ...prev,
      lines: prev.lines.filter(line => line.id !== id)
    }));
  };

  const calculateTotal = () => {
    return formData.lines.reduce((sum, line) => sum + (parseFloat(line.amount) || 0), 0).toFixed(2);
  };

  const handleSaveSubmit = () => {
    if (!formData.supplier || !formData.billNo) {
      Swal.fire({ icon: 'warning', title: 'Missing Info', text: 'Please provide at least Supplier and Bill No.' });
      return;
    }

    // Agar user ne koi item nahi dala, toh ek khali item daal do taake amount 0.00 ho
    let finalLines = formData.lines;
    if (finalLines.length === 0) {
      finalLines = [{ id: 1, category: 'General', description: 'No items added', amount: calculateTotal() }];
    }

    onSave({ formData: { ...formData, lines: finalLines }, file, fileUrl });
    Swal.fire({ icon: 'success', title: 'Saved!', text: 'Bill has been added to the table.', timer: 1500, showConfirmButton: false });
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(17, 24, 39, 0.75)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>

      {/* STEP 1 & 2: Upload Modal */}
      {step <= 2 && (
        <div style={{ backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', width: '100%', maxWidth: '600px', padding: '32px', position: 'relative' }}>
          <button onClick={onClose} disabled={step === 2} style={{ position: 'absolute', top: '16px', right: '16px', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '18px' }}>
            <FaTimes />
          </button>

          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              <span style={{ color: '#2563eb' }}>❖</span> Autofill multiple bills
            </h2>
            <p style={{ color: '#6b7280', fontSize: '14px', marginTop: '4px' }}>Each document you add becomes one new bill</p>
          </div>

          <div style={{ border: '2px dashed #d1d5db', borderRadius: '8px', padding: '40px 20px', textAlign: 'center', backgroundColor: '#f9fafb', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '250px' }}>
            {step === 1 ? (
              <>
                <p style={{ color: '#4b5563', marginBottom: '8px', fontSize: '14px' }}>Drag and drop documents anywhere in the dotted lines or select another option</p>
                <p style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '24px' }}>Supported formats: PDF, PNG, JPEG, HEIC.</p>
                <button onClick={() => fileInputRef.current?.click()} style={{ backgroundColor: '#004aad', color: '#fff', padding: '10px 24px', borderRadius: '4px', fontWeight: '500', border: 'none', cursor: 'pointer', fontSize: '14px' }}>
                  Upload from this device
                </button>
                <input type="file" ref={fileInputRef} onChange={handleFileChange} accept=".pdf,.png,.jpg,.jpeg" style={{ display: 'none' }} />
              </>
            ) : (
              <div style={{ width: '100%' }}>
                <div style={{ marginBottom: '16px', color: '#2563eb', fontSize: '36px' }}>
                  <FaCloudUploadAlt style={{ margin: '0 auto' }} />
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>Scanning document...</h3>
                <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px' }}>{file?.name}</p>
                <div style={{ width: '100%', backgroundColor: '#e5e7eb', borderRadius: '999px', height: '10px', marginBottom: '8px' }}>
                  <div style={{ backgroundColor: '#004aad', height: '10px', borderRadius: '999px', transition: 'width 0.3s', width: `${progress}%` }}></div>
                </div>
                <p style={{ fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>{progress}%</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* STEP 3: Split View Form */}
      {step === 3 && (
        <div style={{ backgroundColor: '#fff', width: '100%', height: '100%', maxWidth: '95vw', maxHeight: '90vh', borderRadius: '8px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', borderBottom: '1px solid #e5e7eb', backgroundColor: '#fff', flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#374151', fontWeight: '600' }}>
              <span style={{ color: '#2563eb', fontSize: '20px' }}>❖</span> Autofill
              <span style={{ color: '#d1d5db', margin: '0 8px' }}>|</span>
              <span style={{ fontSize: '14px', fontWeight: '400' }}>Bill no. {formData.billNo || 'Pending'}</span>
            </div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: '18px' }}>
              <FaTimes />
            </button>
          </div>

          <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
            {/* Left Side Image */}
            <div style={{ width: '50%', backgroundColor: '#111827', padding: '16px', display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#fff', marginBottom: '8px', padding: '0 8px' }}>
                <span style={{ fontSize: '14px' }}>{file?.name}</span>
              </div>
              <div style={{ flex: 1, backgroundColor: '#1f2937', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                {file?.type.includes('pdf') ? (
                  <iframe src={fileUrl} title="PDF Preview" style={{ width: '100%', height: '100%', border: 'none' }} />
                ) : (
                  <img src={fileUrl} alt="Bill Preview" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                )}
              </div>
            </div>

            {/* Right Side Form */}
            <div style={{ width: '50%', backgroundColor: '#fff', padding: '24px', overflowY: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '24px', marginBottom: '16px' }}>
                 <div style={{ textAlign: 'right' }}>
                    <span style={{ color: '#6b7280', textTransform: 'uppercase', fontSize: '10px', fontWeight: 'bold', display: 'block' }}>Supplier</span>
                    <span style={{ color: '#111827', fontWeight: '600', fontSize: '12px' }}>{formData.supplier || '-'}</span>
                 </div>
                 <div style={{ textAlign: 'right' }}>
                    <span style={{ color: '#6b7280', textTransform: 'uppercase', fontSize: '10px', fontWeight: 'bold', display: 'block' }}>Balance Due</span>
                    <span style={{ color: '#111827', fontWeight: '600', fontSize: '12px' }}>£{calculateTotal()}</span>
                 </div>
              </div>

              <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', marginBottom: '24px' }}>Autofill details</h2>
              <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '16px' }}>Review the uploaded document and enter the details below.</p>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Supplier</label>
                  <input type="text" name="supplier" value={formData.supplier} onChange={handleInputChange} placeholder="Enter supplier name" style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '4px', padding: '8px', fontSize: '14px' }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Bill no.</label>
                  <input type="text" name="billNo" value={formData.billNo} onChange={handleInputChange} placeholder="Enter bill number" style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '4px', padding: '8px', fontSize: '14px' }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Bill date</label>
                  <input type="date" name="billDate" value={formData.billDate} onChange={handleInputChange} style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '4px', padding: '8px', fontSize: '14px' }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Due date</label>
                  <input type="date" name="dueDate" value={formData.dueDate} onChange={handleInputChange} style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '4px', padding: '8px', fontSize: '14px' }} />
                </div>
              </div>

              <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden', marginBottom: '24px' }}>
                <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
                  <thead style={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                    <tr>
                      <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '11px', color: '#6b7280' }}>CATEGORY</th>
                      <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '11px', color: '#6b7280' }}>DESCRIPTION</th>
                      <th style={{ padding: '8px 12px', textAlign: 'right', fontSize: '11px', color: '#6b7280' }}>AMOUNT</th>
                      <th style={{ width: '30px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.lines.map((line) => (
                      <tr key={line.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                        <td style={{ padding: '8px 12px' }}>
                          <input type="text" value={line.category} onChange={(e) => handleLineChange(line.id, 'category', e.target.value)} placeholder="Category" style={{ width: '100%', border: 'none', outline: 'none' }} />
                        </td>
                        <td style={{ padding: '8px 12px' }}>
                          <input type="text" value={line.description} onChange={(e) => handleLineChange(line.id, 'description', e.target.value)} placeholder="Description" style={{ width: '100%', border: 'none', outline: 'none' }} />
                        </td>
                        <td style={{ padding: '8px 12px', textAlign: 'right' }}>
                          <input type="number" value={line.amount} onChange={(e) => handleLineChange(line.id, 'amount', e.target.value)} placeholder="0.00" style={{ width: '80px', border: 'none', outline: 'none', textAlign: 'right' }} />
                        </td>
                        <td style={{ padding: '8px', textAlign: 'center' }}>
                           <button onClick={() => removeLine(line.id)} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: '14px' }}>✕</button>
                        </td>
                      </tr>
                    ))}
                    {formData.lines.length === 0 && (
                      <tr><td colSpan="4" style={{ textAlign: 'center', padding: '16px', color: '#9ca3af' }}>No items added. Click below to add.</td></tr>
                    )}
                  </tbody>
                </table>
                <div
                  onClick={addLine}
                  style={{ padding: '8px 12px', backgroundColor: '#f9fafb', borderTop: '1px solid #e5e7eb', fontSize: '12px', color: '#004aad', fontWeight: '600', cursor: 'pointer' }}
                >
                  + Add Line
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '16px', marginBottom: '24px', borderBottom: '1px solid #e5e7eb', paddingBottom: '16px' }}>
                 <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#4b5563' }}>Total</span>
                 <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827' }}>£{calculateTotal()}</span>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Memo</label>
                <textarea name="memo" value={formData.memo} onChange={handleInputChange} placeholder="Add a memo..." style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '4px', padding: '8px', fontSize: '14px', resize: 'vertical' }} rows="3"></textarea>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                <button onClick={onClose} style={{ padding: '8px 16px', fontSize: '14px', border: '1px solid #d1d5db', borderRadius: '4px', color: '#4b5563', backgroundColor: '#fff', cursor: 'pointer' }}>Cancel</button>
                <button onClick={handleSaveSubmit} style={{ padding: '8px 24px', fontSize: '14px', backgroundColor: '#004aad', color: '#fff', borderRadius: '4px', border: 'none', fontWeight: '500', cursor: 'pointer' }}>Save Bill</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AutofillBill;